<template>
  <v-img
    class="bg-image"
    src="https://images.pexels.com/photos/56832/road-asphalt-space-sky-56832.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
    cover
    max-height="100vh"
    gradient="to top right, rgba(49, 51, 63, 0.64), rgba(25,32,72,.9)"
  >
    <v-container fill-height app dark>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xs12 class="text-xs-center">
          <h1
            :class="$vuetify.breakpoint.smAndUp ? 'display-2 text-uppercase white--text' : 'display-1 text-uppercase white--text' "
          >
            State Road
            <span class="font-weight-light">Constructions</span>
          </h1>
        </v-flex>
        <v-flex xs12 sm8 md6 lg5 xl4 class="text-xs-center">
          <v-card class="login-card" theme="dark">
            <v-window class="text-xs-center pb-4 pt-4 pr-5 pl-5" v-model="step">
              <v-window-item :value="1">
                <h3 class="headline white--text">Login to your account</h3>

                <v-form ref="loginForm" @submit.prevent="login()" class="pt-4" dark>
                  <v-text-field
                    :rules="emailRules"
                    type="text"
                    label="Email"
                    append-icon="person"
                    solo-inverted
                    dark
                    v-model="loginEmail"
                  ></v-text-field>
                  <v-text-field
                    :rules="passwordRules"
                    type="password"
                    label="Password"
                    append-icon="lock"
                    solo-inverted
                    dark
                    v-model="loginPassword"
                  ></v-text-field>

                  <!-- <v-btn flat color="" @click="step++" :disabled="loggingIn" dark>Sign Up!</v-btn> -->
                  <v-btn
                    color="primary"
                    type="submit"
                    :loading="loggingIn"
                    depressed
                    dark
                    block
                  >Login</v-btn>
                </v-form>
              </v-window-item>

              <!-- <v-window-item :value="2">
                            <h3 class="headline white--text">Create your account</h3>

                            <v-form ref="signUpForm" @submit.prevent="signUp()" class="pt-4" dark> 
                                <v-text-field
                                :rules="emailRules"
                                type="text"
                                label="Email"
                                append-icon="person"
                                solo-inverted
                                dark
                                v-model="registerEmail"
                                ></v-text-field>
                                <v-text-field
                                :rules="passwordRules"
                                type="password"
                                label="Password"
                                append-icon="lock"
                                solo-inverted
                                dark
                                v-model="registerPassword"
                                ></v-text-field>
                                <v-text-field
                                :rules="passwordRules"
                                type="password"
                                label="Confirm Password"
                                append-icon="lock"
                                solo-inverted
                                dark
                                v-model="registerPasswordConfirm"
                                ></v-text-field>
                                <v-select
                                label="User Access Level"
                                append-icon="security"
                                solo-inverted
                                dark
                                :items="userAuthClasses"
                                v-model="registerUserAuthClassId"
                                item-text="name"
                                item-value="id"
                                >

                                </v-select>
                                <v-btn flat color="" @click="step--" :disabled="signingUp" dark>Have an account?</v-btn>
                                <v-btn color="green" type="submit" :loading="signingUp" dark>Sign Up!</v-btn>
                            
                            </v-form>
              </v-window-item>-->
            </v-window>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      v-model="showSnackbar"
      :right="true"
      :timeout="250000"
      :top="true"
      :vertical="false"
    >
      {{snackbarText}}
      <v-btn :color="snackbarColor" flat @click="showSnackbar = false">Close</v-btn>
    </v-snackbar>
  </v-img>
</template>

<script>
import Auth from "@/services/authenticationService";
import AuthValidation from "@/services/validation/authValidation";
export default {
  mixins: [AuthValidation],
  data() {
    return {
      loggingIn: false,
      signingUp: false,
      step: 1,
      loginEmail: "",
      loginPassword: "",
      registerEmail: "",
      registerPassword: "",
      registerPasswordConfirm: "",
      registerUserAuthClassId: "",
      snackbarText: "",
      showSnackbar: false,
      snackbarColor: "primary",
      userAuthClasses: [
        {
          name: "Administrators",
          id: 1
        },
        {
          name: "Read all",
          id: 2
        }
      ]
    };
  },
  methods: {
    login() {
      if (!this.$refs.loginForm.validate()) {
        this.displaySnackbar("Please correct form errors.", "error");
        return;
      }
      this.loggingIn = true;
      Auth.login({
        email: this.loginEmail,
        password: this.loginPassword
      })
        .then(result => {
          //console.log(result.data);
          this.loggingIn = false;
          this.setLocalStorageTokens(
            result.data.token,
            result.data.refreshToken
          );
          //localStorage.setItem('accessToken', result.data.token);
          this.$router.push({
            name: "dashboard"
          });
        })
        .catch(err => {
          this.loggingIn = false;
          console.log(err.response);
          this.displaySnackbar(
            `${err.response.data.message} (${err.response.status}) `,
            "error"
          );
        });
    },
    // signUp() {
    //     if (!this.$refs.signUpForm.validate()) {
    //         this.displaySnackbar("Please correct form errors.", "error")
    //         return;
    //     }
    //     this.signingUp = true;
    //     Auth.register({
    //         email: this.registerEmail,
    //         name: 'Test User',
    //         password: this.registerPassword,
    //         confirmedPassword: this.registerPasswordConfirm,
    //         userAuthClassId: this.registerUserAuthClassId
    //     }).then(result => {
    //         //console.log(result.data);
    //         this.signingUp = false;
    //         this.setLocalStorageTokens(result.data.token, result.data.refreshToken);
    //         //localStorage.setItem('accessToken', result.data.token);
    //         this.$router.push({
    //             name: "dashboard"
    //         })
    //     }).catch(err => {
    //         console.log(err);
    //         this.signingUp = false;
    //         this.displaySnackbar(`${err.response.data.message} (${err.response.status}) `, "error");
    //     })
    // },
    displaySnackbar(text, color) {
      this.showSnackbar = true;
      this.snackbarColor = color;
      this.snackbarText = text;
    },
    setLocalStorageTokens(token, refreshToken) {
      localStorage.setItem("accessToken", token);
      localStorage.setItem("refreshToken", refreshToken);
    }
  }
};
</script>

<style>
.bg-image {
  /* height:100%; */
  background-image: linear-gradient(
    to top right,
    rgba(100, 115, 201, 0.64),
    rgba(25, 32, 72, 0.9)
  );
}

.login-card {
  background-blend-mode: overlay;
  background: rgba(42, 44, 53, 0.43) !important;
  border-radius: 5px;
  /* filter: blur(8px);
        -webkit-filter: blur(8px); */
}
</style>
